export default "__VITE_ASSET__3d7a9991__"